import client from "./client";

const schoolsApi = {
  async listPublic() {
    const { data } = await client.get("/schools/public");
    return data;
  },

  async getPublicStats() {
    const { data } = await client.get("/schools/stats/public", { _silent: true });
    return data;
  },

  async getBySlug(slug) {
    const { data } = await client.get(`/schools/by-slug/${slug}`, { _silent: true });
    return data;
  },

  list(params = {}) {
    return client.get("/schools", { params }).then((r) => r.data);
  },

  get(id) {
    return client.get(`/schools/${id}`).then((r) => r.data);
  },

  create(body) {
    return client.post("/schools", body).then((r) => r.data);
  },

  update(id, body) {
    return client.patch(`/schools/${id}`, body).then((r) => r.data);
  },

  updateSubscription(id, body) {
    return client.patch(`/schools/${id}/subscription`, body).then((r) => r.data);
  },

  updateAcademic(id, body) {
    return client.patch(`/schools/${id}/academic`, body).then((r) => r.data);
  },

  updateAttendanceConfig(id, body) {
    return client.patch(`/schools/${id}/attendance-config`, body).then((r) => r.data);
  },

  setHolidays(id, holidays) {
    return client.put(`/schools/${id}/holidays`, { holidays }).then((r) => r.data);
  },

  addHoliday(id, holiday) {
    return client.post(`/schools/${id}/holidays`, holiday).then((r) => r.data);
  },

  removeHoliday(id, date) {
    return client.delete(`/schools/${id}/holidays`, { data: { date } }).then((r) => r.data);
  },

  updateFeeConfig(id, body) {
    return client.patch(`/schools/${id}/fee-config`, body).then((r) => r.data);
  },

  // Setup Wizard APIs
  getSetupStatus(schoolId) {
    return client.get(`/schools/${schoolId}/setup`).then((r) => r.data);
  },

  submitBasicInfo(schoolId, body) {
    return client.post(`/schools/${schoolId}/setup/basic-info`, body).then((r) => r.data);
  },

  submitSubjects(schoolId, body) {
    return client.post(`/schools/${schoolId}/setup/subjects`, body).then((r) => r.data);
  },

  submitTeachers(schoolId) {
    return client.post(`/schools/${schoolId}/setup/teachers`).then((r) => r.data);
  },

  submitStudents(schoolId) {
    return client.post(`/schools/${schoolId}/setup/students`).then((r) => r.data);
  },
};

export default schoolsApi;
